(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["everest-language-suggestion"] && !Shopify.designMode) return;
  try {
    (() => {
  const suggestion = document.querySelector('[data-everest-language-suggestion]');
  if (!suggestion) return;
  try { if (sessionStorage.getItem('everest-language-manual')) return; } catch (_) {}
  const targets = Array.from(suggestion.querySelectorAll('[data-everest-suggested-language]'));
  const preferences = (navigator.languages?.length ? navigator.languages : [navigator.language || ''])
    .map(language => language.toLowerCase().split('-')[0]);
  const preferred = preferences.find(language => language === 'en' || targets.some(button => button.dataset.everestSuggestedLanguage === language));
  if (!preferred || preferred === 'en') return;
  if (preferred === suggestion.dataset.currentLanguage.toLowerCase().split('-')[0]) return;
  const target = targets.find(button => button.dataset.everestSuggestedLanguage === preferred);
  if (!target) return;
  const storageKey = 'everest-language-dismissed-' + preferred;
  try { if (sessionStorage.getItem(storageKey)) return; } catch (_) {}
  const message = suggestion.querySelector('[data-everest-language-message]');
  message.textContent = message.textContent.replace('__LANGUAGE__', target.textContent.trim());
  target.hidden = false;
  suggestion.hidden = false;
  suggestion.querySelector('[data-everest-language-dismiss]')?.addEventListener('click', () => {
    suggestion.hidden = true;
    try { sessionStorage.setItem(storageKey, '1'); } catch (_) {}
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["everest-top-language-toggle"] && !Shopify.designMode) return;
  try {
    (() => {
  const toggle = document.querySelector('[data-everest-top-language]');
  if (!toggle || toggle.dataset.ready) return;
  toggle.dataset.ready = 'true';
  const summary = toggle.querySelector('summary');
  document.addEventListener('click', event => {
    const choice = event.target.closest('button[name="language_code"], localization-form [data-value]');
    const language = choice?.value || choice?.dataset.value;
    if (!language) return;
    try { sessionStorage.setItem('everest-language-manual', language); } catch (_) {}
  });
  toggle.addEventListener('keydown', event => {
    if (event.key !== 'Escape' || !toggle.open) return;
    event.preventDefault();
    toggle.open = false;
    summary.focus();
  });
  document.addEventListener('pointerdown', event => {
    if (toggle.open && !toggle.contains(event.target)) toggle.open = false;
  });
  toggle.addEventListener('focusout', event => {
    if (event.relatedTarget && !toggle.contains(event.relatedTarget)) toggle.open = false;
  });
})();
  } catch(e) { console.error(e); }
})();

})();
